import { config } from 'api';

const { sessionTimeout } = config;

export const TIMER_START = 'TIMER_START';
export const TIMER_CLEAR = 'TIMER_CLEAR';

export function startTimer() {
  return () => {
    const timeout = setTimeout(() => {
      window.location.reload(true);
    }, sessionTimeout);

    return {
      type: TIMER_START,
      timeout,
    };
  };
}

export function clearTimer() {
  return (dispatch, getState) => {
    const state = getState();
    const { timeout } = state.dataSync;
    clearTimeout(timeout);

    return {
      type: TIMER_CLEAR,
    };
  };
}

export function restartTimer() {
  return (dispatch) => {
    dispatch(clearTimer());
    dispatch(startTimer());
  };
}
